import { Injectable } from '@angular/core';
import { NavigationExtras } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { RouterState } from '../reducers/router.reducer';
import { selectParams, selectQueryParams } from '../selectors/router.selectors';
import { Back, Go } from '../actions/router.actions';

@Injectable({
  providedIn: 'root',
})
export class RouterFacade {
  params$ = this.store.pipe(select(selectParams));
  queryParams$ = this.store.pipe(select(selectQueryParams));

  navigate(commands: (string | number)[], extras?: NavigationExtras) {
    this.store.dispatch(
      new Go({
        commands,
        extras,
      })
    );
  }

  navigateBack() {
    this.store.dispatch(new Back());
  }

  constructor(protected store: Store<RouterState>) {}
}
